import { render, staticRenderFns } from "./MembersList.vue?vue&type=template&id=1c20a5b6&scoped=true"
import script from "./MembersList.vue?vue&type=script&lang=js"
export * from "./MembersList.vue?vue&type=script&lang=js"
import style0 from "./MembersList.vue?vue&type=style&index=0&id=1c20a5b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20a5b6",
  null
  
)

export default component.exports